import { useCallback, useState } from "react";
import PropTypes from "prop-types";

import KeySelector from "./KeySelector";
import PKey from "./PKey";
import AudioKey from "../../lib/AudioKey";
import { numericKeyValues } from "../../lib/audioTools";

import "./SelectablePKey.scss";

function SelectablePKey({ defaultKeyNumber }) {
	const [key, setKey] = useState(defaultKeyNumber);

	const keyValues = numericKeyValues(key);
	const audioKey = new AudioKey(keyValues.pitch, keyValues.mode);

	const handleKeyChange = useCallback((evt) => {
		const keyNumber = parseInt(evt.target.value, 10);

		if (!Number.isNaN(keyNumber)) {
			setKey(keyNumber);
		}
	}, []);

	return (
		<div className="selectable-pkey">
			<KeySelector onChange={handleKeyChange} selectedKeyNumber={key} />
			<PKey audioKey={audioKey} />
		</div>
	);
}

SelectablePKey.propTypes = {
	defaultKeyNumber: PropTypes.number
};

SelectablePKey.defaultProps = {
	defaultKeyNumber: 0
};

export default SelectablePKey;
